import React from 'react';

import { differenceInCalendarDays } from 'date-fns';
import PropTypes from 'prop-types';

import { formatDate } from '@src/utils/dateTimeHelpers';

import PublishedOn from './PublishedOn';
import UpdatedOn from './UpdatedOn';

export const Publication = (props) => {
    const {
        alertCategory,
        publishedAt,
        webinar,
        updatedAt = new Date(),
        status,
    } = props;

    if (webinar) {
        return null;
    }

    if (alertCategory) {
        if (!publishedAt) {
            return null;
        }

        if (status) {
            if (status === 'updated' || status === 'lifted') {
                return <UpdatedOn>{ formatDate(updatedAt) }</UpdatedOn>;
            }

            return <PublishedOn>{ formatDate(publishedAt) }</PublishedOn>;
        }
    }

    if (!publishedAt) {
        return <span>PUBLISHED DATA NOT SET</span>;
    }

    if (differenceInCalendarDays(new Date(updatedAt), new Date(publishedAt)) > 0) {
        return <UpdatedOn>{formatDate(updatedAt)}</UpdatedOn>;
    }

    return <PublishedOn>{formatDate(publishedAt)}</PublishedOn>;
};

Publication.propTypes = {
    alertCategory: PropTypes.string,
    publishedAt: PropTypes.string,
    status: PropTypes.string,
    webinar: PropTypes.bool,
    updatedAt: PropTypes.string,
};
